import * as React from 'react';
import BackgroundImage from '../../assets/Background-registration.svg';
import Logo from '../../assets/logo_classic.png';
import ManOffice from '../../assets/man-office-worker-medium-light-skin-tone-svgrepo-com.svg';
import IconPerson from '../../assets/Icon akar-person.svg';
import MailOutline from '../../assets/mail_outline.svg';
import KeyOutline from '../../assets/key-outline.svg';
import stylesSign from './SignPigeon.module.css';


export default function SignPigeon() {
  return (
        <div className={stylesSign['registration-container']}>
        <img className={stylesSign['logo-image']} src={Logo} alt="Logo"></img>
        <div className={stylesSign['form-container']}>
            <div className={stylesSign['header-form']}> <span className={stylesSign['row-centering']}> <span className={stylesSign['text-lightgreen']}> Załóż konto </span> <img className={stylesSign['man-office']} src={ManOffice}></img> </span> 
            <br></br><span className={stylesSign['text-grey-sign-small']}> Zaloguj się i zarządzaj dalej swoją hodowlą </span> </div>
            <form>
                
                <label for="name"> <span className={stylesSign['formfield-title']}> Imię </span> </label>
                <div className={stylesSign['input-container']}>
                  <img src={IconPerson} alt="Ikona"></img>
                  <input type="text" id="name" placeholder="Wprowadź swoje imię" className={stylesSign['form-input']}></input>
                </div>

                <div className={stylesSign['interspace-sign']}></div>

                <label for="email"> <span className={stylesSign['formfield-title']}> E-mail </span> </label>
                <div className={stylesSign['input-container']}>
                  <img src={MailOutline} alt="Ikona2"></img>
                  <input type="email" id="email" placeholder="Wprowadź swój adres email" className={stylesSign['form-input']}></input>
                </div>

                <div className={stylesSign['interspace-sign']}></div>

                <label for="password"> <span className={stylesSign['formfield-title']}> Hasło </span> </label>
                <div className={stylesSign['input-container']}>
                  <img src={KeyOutline} alt="Ikona3"></img>
                  <input type="password" id="password" placeholder="**********" className={stylesSign['form-input']}></input>
                </div>

                <div className={stylesSign['interspace-sign']}></div>

                <button type="submit" className={stylesSign['register-button']}>Zarejestruj się</button>
            </form>
        </div>

        <div className={stylesSign['background-image-container']}>
          <img className={stylesSign['background-image-registration']} src={BackgroundImage} alt="Background"></img>
        </div>

      </div>
  );
}